import React from 'react';
import { NavigationStepperItemType } from '../NavigationStepper';
import { NavigationStepperItemsProps } from '../NavigationStepperItems';
import SubTabNavigationStepperItem from './SubTabNavigationStepperItem';

// @ts-ignore
import styles from './SubTabNavigationStepperItems.module.scss';

const SubTabNavigationStepperItems: React.FC<
	NavigationStepperItemsProps
> = props => {
	const { items, onChange, activeKey, firstUpper } = props;

	return (
		<div className={styles.itemsWrapper}>
			<div className={styles.items}>
				{items.map((item: NavigationStepperItemType, index: number) => (
					<SubTabNavigationStepperItem
						item={item}
						key={index}
						onChange={onChange}
						activeKey={activeKey}
						firstUpper={firstUpper}
					/>
				))}
			</div>
		</div>
	);
};

export default SubTabNavigationStepperItems;
